import product_grid_2_X_2 from '../../../static/images/widget/manual/product/product_grid_2_X_2.png';
import product_grid_3_X_2 from '../../../static/images/widget/manual/product/product_grid_3_X_2.png';
import product_swipe_big_1_X_N from '../../../static/images/widget/manual/product/product_swipe_big_1_X_N.png';
import product_swipe_small_1_X_N from '../../../static/images/widget/manual/product/product_swipe_small_1_X_N.png';
import product_gallery_3_X_3 from '../../../static/images/widget/manual/product/product_gallery_3_X_3.png';
import brand_grid_1_X_4 from '../../../static/images/widget/manual/brand/brand_grid_1_X_4.png';
import brand_grid_2_X_2 from '../../../static/images/widget/manual/brand/brand_grid_2_X_2.png';
import brand_scroll_margin_N_X_1 from '../../../static/images/widget/manual/brand/brand_scroll_margin_N_X_1.png';
import brand_scroll_no_margin_N_X_1 from '../../../static/images/widget/manual/brand/brand_scroll_no_margin_N_X_1.png';
import brand_swipe from '../../../static/images/widget/manual/brand/brand_swipe.png';
import event_swipe from '../../../static/images/widget/manual/event/event_swipe.jpg';
import banner_grid_1_X_2 from '../../../static/images/widget/manual/banner/banner_grid_1_X_2.png';
import banner_grid_2_X_2 from '../../../static/images/widget/manual/banner/banner_grid_2_X_2.png';
import banner_scroll_N_X_1 from '../../../static/images/widget/manual/banner/banner_scroll_N_X_1.png';
import banner_swipe_1_dot_5 from '../../../static/images/widget/manual/banner/banner_swipe_1_dot_5.png';
import banner_swipe_2_dot_5 from '../../../static/images/widget/manual/banner/banner_swipe_2_dot_5.png';
import banner_swipe_margin from '../../../static/images/widget/manual/banner/banner_swipe_margin.png';
import banner_swipe_no_margin from '../../../static/images/widget/manual/banner/banner_swipe_no_margin.png';
import time_deal_swipe_1_X_N from '../../../static/images/widget/manual/timeDeal/time_deal_swipe_1_X_N.png';
import { setDateFormat } from '../../../lib/moment';
import { BRAND_UPLOAD_TEMPLATE_XLSX_URL, PRODUCT_UPLOAD_TEMPLATE_XLSX_URL } from '../common/staticFileUrlConstants';
import { CHECK_RADIO_BOX_ALL_TYPE, CHECK_RADIO_BOX_ALL_TYPE_TEXT, DATE_FORMAT } from '../common/utilConstants';
import { APP_LINK_TYPE, APP_LINK_TYPE_TEXT } from '../common/commonConstants';

/**
 *  페이지 이름
 */
export const WIDGET_PAGE_NAME = {
  MAIN_TAB_MANAGEMENT: '홈 탭 등록 및 편집',
  MAIN_PAGE_MANAGEMENT: '메인 페이지 관리',
  SUB_PAGE_LIST: '서브 페이지 리스트',
  SUB_PAGE_CRATE: '서브 페이지 등록',
  SUB_PAGE_MANAGEMENT: '서브 페이지 관리',
  SUB_PAGE_EDIT: '서브 페이지 편집',
  WIDGET_ALL_LIST: '위젯 전체 리스트',
  WIDGET_EDIT: '위젯 편집',
  WIDGET_CREATE: '위젯 등록',
  WIDGET_HOME_MENU_CREATE: '메뉴 등록 및 편집',
  WIDGET_COPY: '위젯 복사',
};

/**
 * 위젯 저장 요청 결과
 * @type {{SUCCESS: string, NONE: string, FAIL: string}}
 */
export const WIDGET_SAVE_RESULT = {
  // 미요청
  NONE: 'NONE',
  // 성공
  SUCCESS: 'SUCCESS',
  // 실패
  FAIL: 'FAIL',
};

/**
 *  위젯 상태
 */
export const WIDGET_STATUS = {
  /**
   *  비활성
   */
  INACTIVE: 0,
  /**
   *  활성
   */
  ACTIVE: 1,
  /**
   *  삭제
   */
  DELETE: 2,
};

/**
 *  위젯 상태 텍스트
 */
export const WIDGET_STATUS_TEXT = {
  [WIDGET_STATUS.INACTIVE]: '비활성',
  [WIDGET_STATUS.ACTIVE]: '활성',
  [WIDGET_STATUS.DELETE]: '삭제',
};

/**
 *  위젯 데이터 타입
 */
export const WIDGET_TYPE = {
  /**
   *  상품
   */
  PRODUCT: 0,
  /**
   *  브랜드
   */
  BRAND: 1,
  /**
   *  기획전
   */
  EVENT: 2,
  /**
   *  배너
   */
  BANNER: 3,
  /**
   *  타임딜
   */
  TIME_DEAL: 4,
};

/**
 *  위젯 아이템 배너 이미지 타입
 */
export const WIDGET_ITEM_BANNER_ATTACHMENT_TYPE = {
  /**
   *  APP 에서 노출되는 이미지
   */
  APP: 0,
  /**
   *  PC 에서 노출되는 이미지
   */
  PC: 1,
};

/**
 *  위젯 아이템 타임딜 이미지 타입
 */
export const WIDGET_ITEM_TIMEDEAL_ATTACHMENT_TYPE = {
  /**
   *  APP 에서 노출되는 이미지
   */
  APP: 0,
  /**
   *  PC 에서 노출되는 이미지
   */
  PC: 1,
};

/**
 *  위젯 아이템 기획전 이미지 타입
 */
export const WIDGET_ITEM_EVENT_ATTACHMENT_TYPE = {
  /**
   *  APP 에서 노출되는 이미지
   */
  APP: 0,
  /**
   *  PC 에서 노출되는 이미지
   */
  PC: 1,
};

/**
 *  위젯 데이터 타입 텍스트
 */
export const WIDGET_TYPE_TEXT = {
  [WIDGET_TYPE.PRODUCT]: '상품',
  [WIDGET_TYPE.BRAND]: '브랜드',
  [WIDGET_TYPE.EVENT]: '기획전',
  [WIDGET_TYPE.BANNER]: '배너',
  [WIDGET_TYPE.TIME_DEAL]: '타임딜',
};

/**
 *  위젯 상품 조건 타입
 */
export const WIDGET_PRODUCTION_CONDITION_TYPE = {
  /**
   *  실판매가
   */
  REAL_PRICE: 0,
  /**
   *  할인가
   */
  DISCOUNT_PRICE: 1,
};

/**
 *  위젯 상품 조건 타입 텍스트
 */
export const WIDGET_PRODUCTION_CONDITION_TYPE_TEXT = {
  [WIDGET_PRODUCTION_CONDITION_TYPE.REAL_PRICE]: '실판매가',
  [WIDGET_PRODUCTION_CONDITION_TYPE.DISCOUNT_PRICE]: '할인가',
};

/**
 *  위젯 상품 조건 초기 최대값
 *  (정액)
 */
export const WIDGET_PRODUCTION_CONDITION_MAX_AMOUNT_VALUE = 10000;

/**
 *  위젯 상품 조건 초기 최대값
 *  (정률)
 */
export const WIDGET_PRODUCTION_CONDITION_MAX_RATE_VALUE = 99;

/**
 *  위젯 상품 조건 타입 SELECT LIST
 */
export const WIDGET_PRODUCTION_CONDITION_TYPE_SELECT_LIST = [
  {
    id: WIDGET_PRODUCTION_CONDITION_TYPE.REAL_PRICE,
    name: WIDGET_PRODUCTION_CONDITION_TYPE_TEXT[WIDGET_PRODUCTION_CONDITION_TYPE.REAL_PRICE],
  },
  {
    id: WIDGET_PRODUCTION_CONDITION_TYPE.DISCOUNT_PRICE,
    name: WIDGET_PRODUCTION_CONDITION_TYPE_TEXT[WIDGET_PRODUCTION_CONDITION_TYPE.DISCOUNT_PRICE],
  },
];

/**
 *  위젯 데이터 타입 SELECT LIST
 */
export const WIDGET_TYPE_SELECT_LIST = [
  {
    id: WIDGET_TYPE.PRODUCT,
    name: WIDGET_TYPE_TEXT[WIDGET_TYPE.PRODUCT],
  },
  {
    id: WIDGET_TYPE.BRAND,
    name: WIDGET_TYPE_TEXT[WIDGET_TYPE.BRAND],
  },
  {
    id: WIDGET_TYPE.EVENT,
    name: WIDGET_TYPE_TEXT[WIDGET_TYPE.EVENT],
  },
  {
    id: WIDGET_TYPE.BANNER,
    name: WIDGET_TYPE_TEXT[WIDGET_TYPE.BANNER],
  },
  {
    id: WIDGET_TYPE.TIME_DEAL,
    name: WIDGET_TYPE_TEXT[WIDGET_TYPE.TIME_DEAL],
  },
];

/**
 *  위젯 모양 타입
 */
export const WIDGET_LAYOUT_TYPE = {
  /**
   *  상품
   */
  [WIDGET_TYPE.PRODUCT]: {
    /**
     *  그리드 2 X 2
     */
    GRID_2_X_2: 0,
    /**
     *  그리드 3 X 2
     */
    GRID_3_X_2: 1,
    /**
     *  스와이프 1 X n (big)
     */
    SWIPE_BIG_1_X_N: 300,
    /**
     *  스와이프 1 X n (small)
     */
    SWIPE_SMALL_1_X_N: 301,
    /**
     *  갤러리 3 X 3
     */
    GALLERY_3_x_3: 400,
  },
  /**
   *  브랜드
   */
  [WIDGET_TYPE.BRAND]: {
    /**
     *  그리드 1 X 4
     */
    GRID_1_X_4: 0,
    /**
     *  그리드 2 X 2
     */
    GRID_2_X_2: 1,
    /**
     *  스크롤 N X 1(공백O)
     */
    SCROLL_MARGIN_N_X_1: 100,
    /**
     *  스크롤 N X 1(공백X)
     */
    SCROLL_NO_MARGIN_N_X_1: 101,
    /**
     *  스와이프
     */
    SWIPE: 200,
  },
  /**
   *  기획전
   */
  [WIDGET_TYPE.EVENT]: {
    /**
     *  스와이프(자동 넘버링)
     */
    SWIPE: 2,
  },
  /**
   *  배너
   */
  [WIDGET_TYPE.BANNER]: {
    /**
     *  스와이프(인디케이터, 공백O)
     */
    SWIPE_MARGIN: 0,
    /**
     *  스와이프(인디케이터, 공백X)
     */
    SWIPE_NO_MARGIN: 1,
    /**
     *  스와이프(1.5개)
     */
    SWIPE_1_DOT_5: 2,
    /**
     *  스와이프(2.5개)
     */
    SWIPE_2_DOT_5: 3,
    /**
     *  그리드 1 X 2
     */
    GRID_1_X_2: 100,
    /**
     *  그리드 2 X 2
     */
    GRID_2_X_2: 101,
    /**
     *  스크롤 N X 1(공백X)
     */
    SCROLL_N_X_1: 200,
  },
  /**
   *  타임딜
   */
  [WIDGET_TYPE.TIME_DEAL]: {
    /**
     *  스와이프 1 X n
     */
    SWIPE_1_X_N: 0,
  },
};

/**
 *  위젯 모양 타입 텍스트
 */
export const WIDGET_LAYOUT_TYPE_TEXT = {
  /**
   *  상품
   */
  [WIDGET_TYPE.PRODUCT]: {
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_2_X_2]: '그리드 2 X 2',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_3_X_2]: '그리드 3 X 2',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_BIG_1_X_N]: '스와이프 1 X N (큰 사이즈)',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_SMALL_1_X_N]: '스와이프 1 X N (작은 사이즈)',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GALLERY_3_x_3]: '갤러리 3 X 3',
  },
  /**
   *  브랜드
   */
  [WIDGET_TYPE.BRAND]: {
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4]: '그리드 1 X 4',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2]: '그리드 2 X 2',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1]: '스크롤 N X 1(공백O)',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1]: '스크롤 N X 1(공백X)',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE]: '스와이프',
  },
  /**
   *  기획전
   */
  [WIDGET_TYPE.EVENT]: {
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.EVENT].SWIPE]: '스와이프(자동, 넘버링)',
  },
  /**
   *  배너
   */
  [WIDGET_TYPE.BANNER]: {
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_MARGIN]: '스와이프(인디케이터, 공백O)',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_NO_MARGIN]: '스와이프(인디케이터, 공백X)',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_1_DOT_5]: '스와이프(1.5개)',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_2_DOT_5]: '스와이프(2.5개)',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_1_X_2]: '그리드 1 X 2',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_2_X_2]: '그리드 2 X 2',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SCROLL_N_X_1]: '스크롤 N X 1(공백X)',
  },
  /**
   *  타임딜
   */
  [WIDGET_TYPE.TIME_DEAL]: {
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.TIME_DEAL].SWIPE_1_X_N]: '스와이프 1 X N',
  },
};

/**
 *  위젯 모양 타입 주의 문구 텍스트
 */
export const WIDGET_LAYOUT_TYPE_NOTI_TEXT = {
  /**
   *  상품
   */
  [WIDGET_TYPE.PRODUCT]: {
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_2_X_2]: '위젯 아이템을 최소 4개, 4개 단위로 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_3_X_2]: '위젯 아이템을 최소 6개, 6개 단위로 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_BIG_1_X_N]: '위젯 아이템을 최소 3개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_SMALL_1_X_N]: '위젯 아이템을 최소 5개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GALLERY_3_x_3]: '위젯 아이템을 최소 9개 선택해주세요.',
  },
  /**
   *  브랜드
   */
  [WIDGET_TYPE.BRAND]: {
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4]: '위젯 아이템을 4개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2]: '위젯 아이템을 4개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1]: '위젯 아이템을 최소 3개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1]: '위젯 아이템을 최소 3개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE]: '위젯 아이템을 최소 2개 선택해주세요.',
  },
  /**
   *  배너
   */
  [WIDGET_TYPE.BANNER]: {
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_MARGIN]: '위젯 아이템을 최소 1개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_NO_MARGIN]: '위젯 아이템을 최소 1개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_1_DOT_5]: '위젯 아이템을 최소 2개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_2_DOT_5]: '위젯 아이템을 최소 3개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_1_X_2]: '위젯 아이템을 2개 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_2_X_2]: '위젯 아이템을 2개 단위로 선택해주세요.',
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SCROLL_N_X_1]: '위젯 아이템을 최소 2개 선택해주세요.',
  },
  /**
   *  타임딜
   */
  [WIDGET_TYPE.TIME_DEAL]: {
    [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.TIME_DEAL].SWIPE_1_X_N]: '위젯에 노출된 상품 정보를 최소 1개 선택해주세요.',
  },
};

/**
 *  위젯 모양 타입 SELECT LIST
 */
export const WIDGET_LAYOUT_TYPE_SELECT_LIST = {
  /**
   *  상품
   */
  [WIDGET_TYPE.PRODUCT]: [
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_2_X_2,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.PRODUCT][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_2_X_2],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_3_X_2,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.PRODUCT][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_3_X_2],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_BIG_1_X_N,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.PRODUCT][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_BIG_1_X_N],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_SMALL_1_X_N,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.PRODUCT][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_SMALL_1_X_N],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GALLERY_3_x_3,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.PRODUCT][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GALLERY_3_x_3],
    },
  ],
  /**
   *  브랜드
   */
  [WIDGET_TYPE.BRAND]: [
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BRAND][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BRAND][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BRAND][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BRAND][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BRAND][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE],
    },
  ],
  /**
   *  스와이프(자동, 넘버링)
   */
  [WIDGET_TYPE.EVENT]: [
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.EVENT].SWIPE,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.EVENT][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.EVENT].SWIPE],
    },
  ],
  /**
   *  배너
   */
  [WIDGET_TYPE.BANNER]: [
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_MARGIN,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BANNER][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_MARGIN],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_NO_MARGIN,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BANNER][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_NO_MARGIN],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_1_DOT_5,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BANNER][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_1_DOT_5],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_2_DOT_5,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BANNER][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_2_DOT_5],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_1_X_2,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BANNER][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_1_X_2],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_2_X_2,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BANNER][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_2_X_2],
    },
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SCROLL_N_X_1,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.BANNER][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SCROLL_N_X_1],
    },
  ],
  /**
   *  스와이프(자동, 넘버링)
   */
  [WIDGET_TYPE.TIME_DEAL]: [
    {
      id: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.TIME_DEAL].SWIPE_1_X_N,
      name: WIDGET_LAYOUT_TYPE_TEXT[WIDGET_TYPE.TIME_DEAL][WIDGET_LAYOUT_TYPE[WIDGET_TYPE.TIME_DEAL].SWIPE_1_X_N],
    },
  ],
};

/**
 *  위젯 노출기간 타입
 */
export const WIDGET_EXPOSURE_TYPE = {
  /**
   *  직접 설정
   */
  DIRECT_SETTING: 0,
  /**
   *  무기한
   */
  INFINITE: 1,
};

/**
 *  위젯 노출기간 타입 텍스트
 */
export const WIDGET_EXPOSURE_TYPE_TEXT = {
  /**
   *  시작 종료 날짜 지정
   */
  [WIDGET_EXPOSURE_TYPE.DIRECT_SETTING]: '직접 설정',
  /**
   *  무기한
   */
  [WIDGET_EXPOSURE_TYPE.INFINITE]: '무기한',
};

/**
 *  위젯 노출기간 타입 SELECT 리스트
 */
export const WIDGET_EXPOSURE_TYPE_SELECT_LIST = [
  {
    id: WIDGET_EXPOSURE_TYPE.DIRECT_SETTING,
    name: WIDGET_EXPOSURE_TYPE_TEXT[WIDGET_EXPOSURE_TYPE.DIRECT_SETTING],
  },
  {
    id: WIDGET_EXPOSURE_TYPE.INFINITE,
    name: WIDGET_EXPOSURE_TYPE_TEXT[WIDGET_EXPOSURE_TYPE.INFINITE],
  },
];

/**
 *  위젯 노출기간 검색 타입 SELECT 리스트
 */
export const WIDGET_EXPOSURE_SEARCH_TYPE_SELECT_LIST = [
  {
    id: CHECK_RADIO_BOX_ALL_TYPE,
    name: CHECK_RADIO_BOX_ALL_TYPE_TEXT,
  },
  ...WIDGET_EXPOSURE_TYPE_SELECT_LIST,
];

/**
 *  위젯 노출기간 업데이트 confirm 메시지
 */
export const UPDATE_WIDGET_EXPOSURE_PERIOD_CONFIRM_MESSAGE = {
  /**
   *  시작 종료 날짜 지정
   */
  [WIDGET_EXPOSURE_TYPE.DIRECT_SETTING]: (exposurePeriod) => {
    const startDate = setDateFormat(exposurePeriod.startDate, DATE_FORMAT.FULL_DASH_FORMAT);
    const endDate = setDateFormat(exposurePeriod.endDate, DATE_FORMAT.FULL_DASH_FORMAT);
    return `해당 위젯의 노출기간은\n ${startDate}~${endDate}입니다.\n 그래도 진행하시겠습니까?`;
  },
  /**
   *  무기한
   */
  [WIDGET_EXPOSURE_TYPE.INFINITE]: () => '해당 위젯은 무기한으로 설정이 되어있습니다.\n 그래도 진행하시겠습니까?',
};

/**
 *  위젯 레이아웃 메뉴얼 리스트
 */
export const WIDGET_LAYOUT_MANUAL = {
  /**
   *  상품
   */
  [WIDGET_TYPE.PRODUCT]: [
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_2_X_2,
      img: product_grid_2_X_2,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_3_X_2,
      img: product_grid_3_X_2,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_BIG_1_X_N,
      img: product_swipe_big_1_X_N,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_SMALL_1_X_N,
      img: product_swipe_small_1_X_N,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GALLERY_3_x_3,
      img: product_gallery_3_X_3,
    },
  ],
  /**
   *  브랜드
   */
  [WIDGET_TYPE.BRAND]: [
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4,
      img: brand_grid_1_X_4,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2,
      img: brand_grid_2_X_2,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1,
      img: brand_scroll_margin_N_X_1,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1,
      img: brand_scroll_no_margin_N_X_1,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE,
      img: brand_swipe,
    },
  ],
  /**
   *  기획전
   */
  [WIDGET_TYPE.EVENT]: [
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.EVENT].SWIPE,
      img: event_swipe,
    },
  ],
  /**
   *  배너
   */
  [WIDGET_TYPE.BANNER]: [
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_MARGIN,
      img: banner_swipe_margin,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_NO_MARGIN,
      img: banner_swipe_no_margin,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_1_DOT_5,
      img: banner_swipe_1_dot_5,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_2_DOT_5,
      img: banner_swipe_2_dot_5,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_1_X_2,
      img: banner_grid_1_X_2,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_2_X_2,
      img: banner_grid_2_X_2,
    },
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SCROLL_N_X_1,
      img: banner_scroll_N_X_1,
    },
  ],
  /**
   *  타임딜
   */
  [WIDGET_TYPE.TIME_DEAL]: [
    {
      layoutType: WIDGET_LAYOUT_TYPE[WIDGET_TYPE.TIME_DEAL].SWIPE_1_X_N,
      img: time_deal_swipe_1_X_N,
    },
  ],
};

/**
 *  위젯 섹션 컴포넌트 타입
 */
export const WIDGET_SECTION_COMPONENT_TYPE = {
  /**
   *  그리드
   */
  GRID: 0,
  /**
   *  스크롤
   */
  SCROLL: 1,
  /**
   *  스와이프
   */
  SWIPE: 2,
  /**
   *  갤러리
   */
  GALLERY: 3,
};

/**
 *  홈에 노출할 수 있는 위젯 홈 상단 이미지
 *  swipe 형태의 위젯 레이아웃
 */
export const ENABLE_TOP_IMG_WIDGET_LAYOUT_TYPE_LIST = [
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_BIG_1_X_N,
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_SMALL_1_X_N,
];

/**
 *  위젯 상품 섹션 레이아웃 타입별 섹션 레이아웃 정보
 */
export const WIDGET_PRODUCT_SECTION_LAYOUT_INFO = {
  /**
   *  grid 2 X 2
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_2_X_2]: [
    {
      /**
       *  노출될 수 있는 위젯 아이템 개수
       */
      NUMBER_OF_WIDGET_ITEM_COUNT: 20,
      /**
       *  위젯 아이템 행렬 레이아웃의 행의 개수
       */
      NUMBER_OF_ROW_COUNT: 2,
      /**
       *  위젯 아이템 행렬 레이아웃의 열의 개수
       */
      NUMBER_OF_COLUMN_COUNT: 2,
      /**
       *  위젯 섹션 컴포넌트 타입
       */
      COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.GRID,
    },
  ],
  /**
   *  grid 3 X 2
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_3_X_2]: [
    {
      /**
       *  노출될 수 있는 위젯 아이템 개수
       */
      NUMBER_OF_WIDGET_ITEM_COUNT: 30,
      /**
       *  위젯 아이템 행렬 레이아웃의 행의 개수
       */
      NUMBER_OF_ROW_COUNT: 3,
      /**
       *  위젯 아이템 행렬 레이아웃의 열의 개수
       */
      NUMBER_OF_COLUMN_COUNT: 2,
      /**
       *  위젯 섹션 컴포넌트 타입
       */
      COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.GRID,
    },
  ],
  /**
   *  swipe 1 X n (big)
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_BIG_1_X_N]: [
    {
      /**
       *  노출될 수 있는 위젯 아이템 개수
       */
      NUMBER_OF_WIDGET_ITEM_COUNT: 10,
      /**
       *  스와이프 사이즈
       */
      SWIPE_SIZE: 'big',
      /**
       *  위젯 섹션 컴포넌트 타입
       */
      COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.SWIPE,
    },
  ],
  /**
   *  swipe 1 X n (small)
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_SMALL_1_X_N]: [
    {
      /**
       *  노출될 수 있는 위젯 아이템 개수
       */
      NUMBER_OF_WIDGET_ITEM_COUNT: 10,
      /**
       *  스와이프 사이즈
       */
      SWIPE_SIZE: 'small',
      /**
       *  위젯 섹션 컴포넌트 타입
       */
      COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.SWIPE,
    },
  ],
  /**
   *  gallery 3 X 3
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GALLERY_3_x_3]: [
    {
      /**
       *  노출될 수 있는 위젯 아이템 개수
       */
      NUMBER_OF_WIDGET_ITEM_COUNT: 9,
      /**
       *  위젯 섹션 컴포넌트 타입
       */
      COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.GALLERY,
    },
  ],
};

/**
 *  위젯 브랜드 섹션 레이아웃 타입별 섹션 레이아웃 정보
 */
export const WIDGET_BRAND_SECTION_LAYOUT_INFO = {
  /**
   *  grid 1 X 4
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4]: {
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 4,
    /**
     *  위젯 아이템 행렬 레이아웃의 행의 개수
     */
    NUMBER_OF_ROW_COUNT: 1,
    /**
     *  위젯 아이템 행렬 레이아웃의 열의 개수
     */
    NUMBER_OF_COLUMN_COUNT: 4,
  },
  /**
   *  grid 2 X 2
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2]: {
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 4,
    /**
     *  위젯 아이템 행렬 레이아웃의 행의 개수
     */
    NUMBER_OF_ROW_COUNT: 2,
    /**
     *  위젯 아이템 행렬 레이아웃의 열의 개수
     */
    NUMBER_OF_COLUMN_COUNT: 2,
  },
  /**
   *  스크롤 N X 1(공백O)
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1]: {
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 4,
    /**
     *  위젯 아이템 행렬 레이아웃의 행의 개수
     */
    NUMBER_OF_ROW_COUNT: 2,
    /**
     *  위젯 아이템 행렬 레이아웃의 열의 개수
     */
    NUMBER_OF_COLUMN_COUNT: 2,
  },
  /**
   *  스크롤 N X 1(공백X)
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1]: {
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 4,
    /**
     *  위젯 아이템 행렬 레이아웃의 행의 개수
     */
    NUMBER_OF_ROW_COUNT: 2,
    /**
     *  위젯 아이템 행렬 레이아웃의 열의 개수
     */
    NUMBER_OF_COLUMN_COUNT: 2,
  },
  /**
   *  swipe
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE]: {
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 5,
  },
};

/**
 *  위젯 기획전 섹션 레이아웃 타입별 섹션 레이아웃 정보
 */
export const WIDGET_EVENT_SECTION_LAYOUT_INFO = {
  /**
   *  스와이프(자동, 넘버링)
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.EVENT].SWIPE]: {
    /**
     *  노출될 수 있는 위젯 아이템 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 30,
  },
};

/**
 *  위젯 배너 섹션 레이아웃 타입별 섹션 레이아웃 정보
 */
export const WIDGET_BANNER_SECTION_LAYOUT_INFO = {
  /**
   *  공백 존재
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_MARGIN]: {
    /**
     *  노출될 수 있는 위젯 아이템 최소 개수
     */
    MINIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 1,
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 10,
    /**
     *  위젯 섹션 컴포넌트 타입
     */
    COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.SWIPE,
    /**
     *  이미지 공백 사용하지 않은 여부
     */
    IS_NOT_IMG_MARGIN: false,
    /**
     *  스와이프 인티케이터 사용 여부
     */
    IS_SWIPE_INDICATOR: true,
  },
  /**
   *  공백 존재하지 않음
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_NO_MARGIN]: {
    /**
     *  노출될 수 있는 위젯 아이템 최소 개수
     */
    MINIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 1,
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 10,
    /**
     *  위젯 섹션 컴포넌트 타입
     */
    COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.SWIPE,
    /**
     *  이미지 공백 사용하지 않은 여부
     */
    IS_NOT_IMG_MARGIN: true,
    /**
     *  스와이프 인티케이터 사용 여부
     */
    IS_SWIPE_INDICATOR: true,
  },
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_1_DOT_5]: {
    /**
     *  노출될 수 있는 위젯 아이템 최소 개수
     */
    MINIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 1,
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 10,
    /**
     *  위젯 섹션 컴포넌트 타입
     */
    COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.SWIPE,
    /**
     *  스와이프 노출 슬라이드 개수
     */
    SLIDE_TO_SHOW: 1,
    /**
     *  이미지 공백 사용하지 않은 여부
     */
    IS_NOT_IMG_MARGIN: false,
    /**
     *  스와이프 인티케이터 사용 여부
     */
    IS_SWIPE_INDICATOR: false,
  },
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SWIPE_2_DOT_5]: {
    /**
     *  노출될 수 있는 위젯 아이템 최소 개수
     */
    MINIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 1,
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 10,
    /**
     *  위젯 섹션 컴포넌트 타입
     */
    COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.SWIPE,
    /**
     *  스와이프 노출 슬라이드 개수
     */
    SLIDE_TO_SHOW: 2,
    /**
     *  이미지 공백 사용하지 않은 여부
     */
    IS_NOT_IMG_MARGIN: false,
    /**
     *  스와이프 인티케이터 사용 여부
     */
    IS_SWIPE_INDICATOR: false,
  },
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_1_X_2]: {
    /**
     *  노출될 수 있는 위젯 아이템 최소 개수
     */
    MINIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 1,
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 2,
    /**
     *  위젯 섹션 컴포넌트 타입
     */
    COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.GRID,
    /**
     *  위젯 아이템 행렬 레이아웃의 열의 개수
     */
    NUMBER_OF_COLUMN_COUNT: 2,
  },
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].GRID_2_X_2]: {
    /**
     *  노출될 수 있는 위젯 아이템 최소 개수
     */
    MINIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 1,
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 4,
    /**
     *  위젯 섹션 컴포넌트 타입
     */
    COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.GRID,
    /**
     *  위젯 아이템 행렬 레이아웃의 열의 개수
     */
    NUMBER_OF_COLUMN_COUNT: 2,
  },
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BANNER].SCROLL_N_X_1]: {
    /**
     *  노출될 수 있는 위젯 아이템 최소 개수
     */
    MINIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 1,
    /**
     *  노출될 수 있는 위젯 아이템 최대 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 10,
    /**
     *  위젯 섹션 컴포넌트 타입
     */
    COMPONENT_TYPE: WIDGET_SECTION_COMPONENT_TYPE.SCROLL,
  },
};

/**
 *  위젯 타임딜 섹션 레이아웃 타입별 섹션 레이아웃 정보
 */
export const WIDGET_TIMEDEAL_SECTION_LAYOUT_INFO = {
  /**
   *  스와이프(자동, 넘버링)
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.TIME_DEAL].SWIPE_1_X_N]: {
    /**
     *  노출될 수 있는 위젯 아이템 개수
     */
    MAXIMUM_NUMBER_OF_WIDGET_ITEM_COUNT: 18,
  },
};

/**
 *  랜덤시 노출할 수 있는 위젯 상품 개수 SELECT LIST 정보
 */
export const WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_INFO = {
  /**
   *  grid 2 X 2
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_2_X_2]: {
    MIN_VALUE: 4,
    UNIT_COUNT: 4,
    RANGE: 5,
  },
  /**
   *  grid 3 X 2
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GRID_3_X_2]: {
    MIN_VALUE: 6,
    UNIT_COUNT: 6,
    RANGE: 5,
  },
  /**
   *  swipe 1 X n (big)
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_BIG_1_X_N]: {
    MIN_VALUE: 2,
    UNIT_COUNT: 1,
    RANGE: 9,
  },
  /**
   *  swipe 1 X n (small)
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_SMALL_1_X_N]: {
    MIN_VALUE: 3,
    UNIT_COUNT: 1,
    RANGE: 8,
  },
  /**
   *  gallery 3 X 3
   */
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].GALLERY_3_x_3]: {
    MIN_VALUE: 9,
    UNIT_COUNT: 0,
    RANGE: 1,
  },
};

/**
 *  아몬즈 웹/앱 페이지 링크 타입
 */
export const WIDGET_ITEM_LINK_ID_TYPE = {
  /**
   *  브랜드 상세 페이지
   */
  BRAND_DETAIL: APP_LINK_TYPE.BRAND_DETAIL,
  /**
   *  기획전 상세 페이지
   */
  EVENT_DETAIL: APP_LINK_TYPE.EVENT_DETAIL,
  /**
   *  상품 목록 페이지
   */
  PRODUCT_LIST: APP_LINK_TYPE.PRODUCT_LIST,
  /**
   *  브랜드 목록 페이지
   */
  BRAND_LIST: APP_LINK_TYPE.BRAND_LIST,
  /**
   *  찜 상품 목록 페이지
   */
  LIKE_PRODUCT_LIST: APP_LINK_TYPE.LIKE_PRODUCT_LIST,
  /**
   *  찜 브랜드 목록 페이지
   */
  LIKE_BRAND_LIST: APP_LINK_TYPE.LIKE_BRAND_LIST,
  /**
   *  장바구니 페이지
   */
  CART: APP_LINK_TYPE.CART,
  /**
   *  포인트 페이지
   */
  POINT: APP_LINK_TYPE.POINT,
  /**
   *  쿠폰 페이지
   */
  COUPON: APP_LINK_TYPE.COUPON,
  /**
   *  레퍼럴 페이지
   */
  REFERRAL: APP_LINK_TYPE.REFERRAL,
  /**
   *  주문 배송 조회 목록
   */
  ORDER_DELIVERY_SEARCH_LIST: APP_LINK_TYPE.ORDER_DELIVERY_SEARCH_LIST,
  /**
   *  상품 후기 쓰기 탭
   */
  REVIEW_WRITE_TAB: APP_LINK_TYPE.REVIEW_WRITE_TAB,
  /**
   *  상품 후기 작성한 내역 탭
   */
  REVIEW_HISTORY_TAB: APP_LINK_TYPE.REVIEW_HISTORY_TAB,
  /**
   *  회원정보 수정 페이지
   */
  MEMBER_INFO_EDIT: APP_LINK_TYPE.MEMBER_INFO_EDIT,
  /**
   *  알림 설정 페이지
   */
  SET_ALARM: APP_LINK_TYPE.SET_ALARM,
  /**
   *  상품 상세 페이지
   */
  PRODUCT_DETAIL: APP_LINK_TYPE.PRODUCT_DETAIL,
  /**
   *  후기 상세
   */
  REVIEW_DETAIL: APP_LINK_TYPE.REVIEW_DETAIL,
  /**
   *  태그 탭
   */
  TAG_TAB: APP_LINK_TYPE.TAG_TAB,
  /**
   *  태그 상세 - 갤러리
   */
  TAG_DETAIL_GALLERY: APP_LINK_TYPE.TAG_DETAIL_GALLERY,
  /**
   *  태그 상세 - 피드
   */
  TAG_DETAIL_FEED: APP_LINK_TYPE.TAG_DETAIL_FEED,
  /**
   *  웹페이지
   */
  WEB_PAGE: APP_LINK_TYPE.WEB_PAGE,
  /**
   *  카테고리 페이지
   */
  CATEGORY_PAGE: APP_LINK_TYPE.CATEGORY_PAGE,
  /**
   * 홈 페이지(메인, 서브)
   */
  HOME_PAGE: APP_LINK_TYPE.HOME_PAGE,
};

/**
 *  아몬즈 웹/앱 페이지 링크 타입 텍스트
 */
export const WIDGET_ITEM_LINK_ID_TYPE_TEXT = {
  [WIDGET_ITEM_LINK_ID_TYPE.BRAND_DETAIL]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.BRAND_DETAIL],
  [WIDGET_ITEM_LINK_ID_TYPE.EVENT_DETAIL]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.EVENT_DETAIL],
  [WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_LIST]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_LIST],
  [WIDGET_ITEM_LINK_ID_TYPE.BRAND_LIST]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.BRAND_LIST],
  [WIDGET_ITEM_LINK_ID_TYPE.LIKE_PRODUCT_LIST]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.LIKE_PRODUCT_LIST],
  [WIDGET_ITEM_LINK_ID_TYPE.LIKE_BRAND_LIST]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.LIKE_BRAND_LIST],
  [WIDGET_ITEM_LINK_ID_TYPE.CART]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.CART],
  [WIDGET_ITEM_LINK_ID_TYPE.POINT]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.POINT],
  [WIDGET_ITEM_LINK_ID_TYPE.COUPON]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.COUPON],
  [WIDGET_ITEM_LINK_ID_TYPE.REFERRAL]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.REFERRAL],
  [WIDGET_ITEM_LINK_ID_TYPE.ORDER_DELIVERY_SEARCH_LIST]:
    APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.ORDER_DELIVERY_SEARCH_LIST],
  [WIDGET_ITEM_LINK_ID_TYPE.REVIEW_WRITE_TAB]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.REVIEW_WRITE_TAB],
  [WIDGET_ITEM_LINK_ID_TYPE.REVIEW_HISTORY_TAB]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.REVIEW_HISTORY_TAB],
  [WIDGET_ITEM_LINK_ID_TYPE.MEMBER_INFO_EDIT]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.MEMBER_INFO_EDIT],
  [WIDGET_ITEM_LINK_ID_TYPE.SET_ALARM]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.SET_ALARM],
  [WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL],
  [WIDGET_ITEM_LINK_ID_TYPE.REVIEW_DETAIL]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.REVIEW_DETAIL],
  [WIDGET_ITEM_LINK_ID_TYPE.TAG_TAB]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.TAG_TAB],
  [WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_GALLERY]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_GALLERY],
  [WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_FEED]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_FEED],
  [WIDGET_ITEM_LINK_ID_TYPE.WEB_PAGE]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.WEB_PAGE],
  [WIDGET_ITEM_LINK_ID_TYPE.CATEGORY_PAGE]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.CATEGORY_PAGE],
  [WIDGET_ITEM_LINK_ID_TYPE.HOME_PAGE]: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.HOME_PAGE],
};

/**
 *  홈 메뉴 위젯 링크 타입 SELECT 리스트
 */
export const WIDGET_HOME_MENU_LINK_TYPE_SELECT_LIST = [
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.BRAND_DETAIL,
    name: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.BRAND_DETAIL],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.EVENT_DETAIL,
    name: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.EVENT_DETAIL],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.CATEGORY_PAGE,
    name: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.CATEGORY_PAGE],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.WEB_PAGE,
    name: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.WEB_PAGE],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.HOME_PAGE,
    name: APP_LINK_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.HOME_PAGE],
  },
];

/**
 *  위젯 링크 타입 SELECT 리스트
 */
export const WIDGET_ITEM_LINK_ID_TYPE_SELECT_LIST = [
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.BRAND_DETAIL,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.BRAND_DETAIL],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.EVENT_DETAIL,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.EVENT_DETAIL],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_LIST,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_LIST],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.BRAND_LIST,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.BRAND_LIST],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.LIKE_PRODUCT_LIST,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.LIKE_PRODUCT_LIST],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.LIKE_BRAND_LIST,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.LIKE_BRAND_LIST],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.CART,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.CART],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.POINT,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.POINT],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.COUPON,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.COUPON],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.REFERRAL,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.REFERRAL],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.ORDER_DELIVERY_SEARCH_LIST,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.ORDER_DELIVERY_SEARCH_LIST],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.REVIEW_WRITE_TAB,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.REVIEW_WRITE_TAB],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.REVIEW_HISTORY_TAB,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.REVIEW_HISTORY_TAB],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.MEMBER_INFO_EDIT,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.MEMBER_INFO_EDIT],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.SET_ALARM,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.SET_ALARM],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.REVIEW_DETAIL,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.REVIEW_DETAIL],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.TAG_TAB,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.TAG_TAB],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_GALLERY,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_GALLERY],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_FEED,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_FEED],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.WEB_PAGE,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.WEB_PAGE],
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.CATEGORY_PAGE,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.CATEGORY_PAGE],
  },
];

/**
 *  타임딜 위젯 링크 타입 SELECT 리스트
 */
export const TIMEDEAL_WIDGET_ITEM_LINK_ID_TYPE_SELECT_LIST = [
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL,
    name: WIDGET_ITEM_LINK_ID_TYPE_TEXT[WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL],
  },
];

/**
 *  위젯 링크 ID 를 검색할 수 있는 위젯 배너 아이템 링크 타입 리스트
 */
export const ENABLE_SEARCH_WIDGET_BANNER_ITEM_LINK_TYPE_LIST = [
  /**
   *  브랜드 상세 페이지
   */
  WIDGET_ITEM_LINK_ID_TYPE.BRAND_DETAIL,
  /**
   *  기획전 상세 페이지
   */
  WIDGET_ITEM_LINK_ID_TYPE.EVENT_DETAIL,
  /**
   *  상품 상세 페이지
   */
  WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL,
  /**
   *  후기 상세
   */
  WIDGET_ITEM_LINK_ID_TYPE.REVIEW_DETAIL,
  /**
   *  태그 상세 - 갤러리
   */
  WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_GALLERY,
  /**
   *  태그 상세 - 피드
   */
  WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_FEED,
];

/**
 *  위젯 링크 ID를 검색할 수 있는 위젯 배너 아이템 링크 타입 정보 리스트
 */
export const ENABLE_SEARCH_WIDGET_BANNER_ITEM_LINK_TYPE_INFO_LIST = [
  /**
   *  상점 검색
   */
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.BRAND_DETAIL,
    targetModal: 'searchStoreListModal',
  },
  /**
   *  기획전 검색
   */
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.EVENT_DETAIL,
    targetModal: 'searchEventListModal',
  },
  /**
   *  상품 검색
   */
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.PRODUCT_DETAIL,
    targetModal: 'searchProductListModal',
  },
  /**
   *  후기 검색
   */
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.REVIEW_DETAIL,
    targetModal: 'searchReviewListModal',
  },
  /**
   *  태그 검색
   */
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_GALLERY,
    targetModal: 'searchTagListModal',
  },
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.TAG_DETAIL_FEED,
    targetModal: 'searchTagListModal',
  },
  /**
   * 홈 페이지 검색
   */
  {
    id: WIDGET_ITEM_LINK_ID_TYPE.HOME_PAGE,
    targetModal: 'searchHomeListModal',
  },
];

/**
 *  위젯 타이틀이 필수옵션인
 *  위젯 타입 리스트
 */
export const REQUIRED_OPTION_WIDGET_TITLE_WIDGET_TYPE_LIST = [
  WIDGET_TYPE.PRODUCT,
  WIDGET_TYPE.BRAND,
  WIDGET_TYPE.EVENT,
  WIDGET_TYPE.TIME_DEAL,
];

/**
 *  위젯 브랜드 아이템 이미지가 옵션인
 *  위젯 브랜드 레이아웃 타입 리스트
 */
export const ENABLE_BRAND_ITEM_IMG_BRAND_LAYOUT_TYPE_LIST = [
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1,
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1,
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE,
];

/**
 *  위젯 브랜드 아이템 타이틀이 필수옵션인
 *  위젯 브랜드 레이아웃 타입 리스트
 */
export const REQUIRED_OPTION_ITEM_TITLE_BRAND_LAYOUT_TYPE_LIST = [
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4,
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2,
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE,
];

/**
 *  위젯 브랜드 아이템 콘텐츠가 옵션인
 *  위젯 브랜드 레이아웃 타입 리스트
 */
export const ENABLE_BRAND_ITEM_CONTENTS_BRAND_LAYOUT_TYPE_LIST = [
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2,
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1,
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1,
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE,
];

/**
 *  위젯 브랜드 아이템 콘텐츠가 필수옵션인
 *  위젯 브랜드 레이아웃 타입 리스트
 */
export const REQUIRED_OPTION_ITEM_CONTENTS_BRAND_LAYOUT_TYPE_LIST = [
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2,
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE,
];

/**
 *  브랜드명과 좋아요 버튼이 필요없는
 *  위젯 상품 레이아웃
 */
export const UNNECESSARY_BRAND_NAME_AND_LIKE_BUTTON_PRODUCT_LAYOUT_TYPE_LIST = [
  WIDGET_LAYOUT_TYPE[WIDGET_TYPE.PRODUCT].SWIPE_SMALL_1_X_N,
];

/**
 *  위젯 상품 아이템 최대 개수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_PRODUCT_ITEM = 1000;

/**
 *  위젯 배너 아이템 당 이미지 업로드 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_BANNER_ITEM_ATTACHMENT = 1;

/**
 *  위젯 타임딜 아이템 당 이미지 업로드 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_TIMEDEAL_ITEM_ATTACHMENT = 1;

/**
 *  위젯 기획전 아이템 당 이미지 업로드 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_EVENT_ITEM_ATTACHMENT = 1;

/**
 *  위젯 브랜드 아이템 당 이미지 업로드 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_BRAND_ITEM_ATTACHMENT = 1;

/**
 *  위젯 등록 페이지 패널 name
 */
export const WIDGET_SAVE_PAGE_PANEL_NAME = {
  /**
   *  위젯 브랜드 섹션
   */
  WIDGET_BRAND_SECTION: 'widget-brand-section',
  /**
   *  위젯 기획전 섹션
   */
  WIDGET_EVENT_SECTION: 'widget-event-section',
  /**
   *  위젯 배너 섹션
   */
  WIDGET_BANNER_SECTION: 'widget-banner-section',
  /**
   *  위젯 타임딜 섹션
   */
  WIDGET_TIMEDEAL_SECTION: 'widget-timedeal-section',
};

/**
 *  위젯 타입별 기간 막대 색상
 */
export const WIDGET_TYPE_PERIOD_BAR_COLOR = {
  /**
   *  상품
   */
  [WIDGET_TYPE.PRODUCT]: {
    bgColor: '#dee2e6',
  },
  /**
   *  브랜드
   */
  [WIDGET_TYPE.BRAND]: {
    bgColor: '#e599f7',
  },
  /**
   *  기획전
   */
  [WIDGET_TYPE.EVENT]: {
    bgColor: '#ffc078',
  },
  /**
   *  배너
   */
  [WIDGET_TYPE.BANNER]: {
    bgColor: '#91a7ff',
  },
  /**
   *  타임딜
   */
  [WIDGET_TYPE.TIME_DEAL]: {
    bgColor: '#993366',
  },
};

/**
 *  위젯 검색 키워드 타입
 */
export const WIDGET_SEARCH_KEYWORD_TYPE = {
  /**
   *  메인 타이틀
   */
  MAIN_TITLE: 0,
  /**
   *  서브 타이틀
   */
  SUB_TITLE: 1,
  /**
   *  메모
   */
  MEMO: 2,
};

/**
 *  위젯 검색 키워드 타입 TEXT
 */
export const WIDGET_ALL_LIST_SEARCH_KEYWORD_TYPE_TEXT = {
  [WIDGET_SEARCH_KEYWORD_TYPE.MAIN_TITLE]: '메인 타이틀',
  [WIDGET_SEARCH_KEYWORD_TYPE.SUB_TITLE]: '서브 타이틀',
  [WIDGET_SEARCH_KEYWORD_TYPE.MEMO]: '메모',
};

/**
 *  위젯 검색 키워드 타입 SELECT LIST
 */
export const WIDGET_SEARCH_KEYWORD_TYPE_SELECT_LIST = [
  {
    id: null,
    name: '전체',
  },
  {
    id: WIDGET_SEARCH_KEYWORD_TYPE.MAIN_TITLE,
    name: WIDGET_ALL_LIST_SEARCH_KEYWORD_TYPE_TEXT[WIDGET_SEARCH_KEYWORD_TYPE.MAIN_TITLE],
  },
  {
    id: WIDGET_SEARCH_KEYWORD_TYPE.SUB_TITLE,
    name: WIDGET_ALL_LIST_SEARCH_KEYWORD_TYPE_TEXT[WIDGET_SEARCH_KEYWORD_TYPE.SUB_TITLE],
  },
  {
    id: WIDGET_SEARCH_KEYWORD_TYPE.MEMO,
    name: WIDGET_ALL_LIST_SEARCH_KEYWORD_TYPE_TEXT[WIDGET_SEARCH_KEYWORD_TYPE.MEMO],
  },
];

/**
 *  위젯 타이틀의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_MAIN_TITLE_TEXT = 20;

/**
 *  위젯 서브 타이틀의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_SUB_TITLE_TEXT = 20;

/**
 *  위젯 메모의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_MEMO_TEXT = 1000;

/**
 *  위젯 버튼명의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_BUTTON_TEXT = 10;

/**
 *  위젯 위젯 노출기간 PLACEHOLDER 텍스트
 */
export const PLACEHOLDER_TEXT_WIDGET_EXPOSURE_PERIOD_DATE = 'YYYY년 M월 D일 H시 m분 s초';

/**
 *  위젯 상점 아이템 타이틀의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_STORE_ITEM_TITLE_TEXT = 20;

/**
 *  위젯 상점 아이템 내용의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_STORE_ITEM_CONTENT_TEXT = {
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2]: 15,
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1]: 50,
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1]: 50,
  [WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE]: 50,
};

/**
 *  위젯 배너 아이템 메모의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_BANNER_ITEM_MEMO_TEXT = 250;

/**
 *  위젯 타임딜 아이템 메모의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_TIMEDEAL_ITEM_MEMO_TEXT = 250;

/**
 *  위젯 기획전 아이템 메모의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_EVENT_ITEM_MEMO_TEXT = 250;

/**
 *  홈 메뉴 타이틀의 글자 수
 */
export const MAXIMUM_NUMBER_OF_HOME_MENU_TEXT = 8;

/**
 *  홈 메뉴 메모의 글자 수
 */
export const MAXIMUM_NUMBER_OF_HOME_MENU_MEMO_TEXT = 250;

/**
 *  위젯 배너 타이틀의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_BANNER_ITEM_TITLE_TEXT = 20;

/**
 *  위젯 배너 내용의 글자 수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_BANNER_ITEM_CONTENTS_TEXT = 50;

/**
 *  선택된 기획전 리스트가 없을 때 보여주는 텍스트
 */
export const SELECTED_SEARCH_EVENT_LIST_TABLE_EMPTY_TEXT = '선택된 기획전 리스트가 없습니다.';

/**
 *  기획전 리스트가 없을 때 보여주는 텍스트
 */
export const SEARCH_EVENT_LIST_TABLE_EMPTY_TEXT = '기획전 리스트가 없습니다.';

/**
 *  선택된 브랜드 리스트가 없을 때 보여주는 텍스트
 */
export const SELECTED_SEARCH_STORE_LIST_TABLE_EMPTY_TEXT = '선택된 브랜드 리스트가 없습니다.';

/**
 *  브랜드 리스트가 없을 때 보여주는 텍스트
 */
export const SEARCH_STORE_LIST_TABLE_EMPTY_TEXT = '브랜드 리스트가 없습니다.';

/**
 *  선택된 상품 리스트가 없을 때 보여주는 텍스트
 */
export const SELECTED_SEARCH_PRODUCT_LIST_TABLE_EMPTY_TEXT = '선택된 상품 리스트가 없습니다.';

/**
 *  상품 리스트가 없을 때 보여주는 텍스트
 */
export const SEARCH_PRODUCT_LIST_TABLE_EMPTY_TEXT = '상품 리스트가 없습니다.';

/**
 *  선택된 상품 후기 리스트가 없을 때 보여주는 텍스트
 */
export const SELECTED_SEARCH_REVIEW_LIST_TABLE_EMPTY_TEXT = '선택된 상품 후기 리스트가 없습니다.';

/**
 *  상품 후기 리스트가 없을 때 보여주는 텍스트
 */
export const SEARCH_REVIEW_LIST_TABLE_EMPTY_TEXT = '상품 후기 리스트가 없습니다.';

/**
 *  선택된 태그 리스트가 없을 때 보여주는 텍스트
 */
export const SELECTED_SEARCH_TAG_LIST_TABLE_EMPTY_TEXT = '선택된 태그 리스트가 없습니다.';

/**
 *  태그 리스트가 없을 때 보여주는 텍스트
 */
export const SEARCH_TAG_LIST_TABLE_EMPTY_TEXT = '태그 리스트가 없습니다.';

/**
 *  선택된 기획전 리스트가 없을 때 보여주는 텍스트
 */
export const SELECTED_SEARCH_HOME_MENU_LIST_TABLE_EMPTY_TEXT = '선택된 서브페이지 리스트가 없습니다.';

/**
 *  태그 리스트가 없을 때 보여주는 텍스트
 */
export const SEARCH_HOME_MENU_LIST_TABLE_EMPTY_TEXT = '서브페이지 리스트가 없습니다.';

/**
 *  위젯 타입별 엑셀 업로드 템플릿
 */
export const WIDGET_ITEM_EXCEL_UPLOAD_TEMPLATE_FILE_NAME = {
  /**
   *  상품
   */
  [WIDGET_TYPE.PRODUCT]: PRODUCT_UPLOAD_TEMPLATE_XLSX_URL,
  /**
   *  브랜드
   */
  [WIDGET_TYPE.BRAND]: BRAND_UPLOAD_TEMPLATE_XLSX_URL,
};

/**
 *  위젯 비교 미리보기 섹션 id
 */
export const WIDGET_PREVIEW_COMPARE_SECTION_ID = {
  /**
   *  변경 전
   */
  BEFORE_UPDATED_SECTION: 'before-updated-section-id',
  /**
   *  변경 후
   */
  AFTER_UPDATED_SECTION: 'after-updated-section-id',
};

/**
 *  위젯 비교 미리보기 섹션 id 활성 state
 */
export const WIDGET_PREVIEW_COMPARE_SECTION_ID_ACTIVE_STATE = {
  [WIDGET_PREVIEW_COMPARE_SECTION_ID.BEFORE_UPDATED_SECTION]: 'beforeActiveWidgetId',
  [WIDGET_PREVIEW_COMPARE_SECTION_ID.AFTER_UPDATED_SECTION]: 'afterActiveWidgetId',
};

/**
 *  위젯 상세 상단 이미지 최대 개수
 */
export const MAXIMUM_NUMBER_OF_WIDGET_DETAIL_TOP_IMG = 100;

/**
 *  S3 에 저장 될 홈 메뉴 이미지 너비
 */
export const HOMEMENU_IMG_WIDTH = 216;

/**
 *  S3 에 저장 될 홈 메뉴 이미지 높이
 */
export const HOMEMENU_IMG_HEIGHT = 216;

/**
 *  서브 페이지 제목 최대 글자 수
 */
export const MAXIMUM_NUMBER_OF_SUB_PAGE_TITLE_TEXT = 8;

/**
 *  서브 페이지 메모의 글자 수
 */
export const MAXIMUM_NUMBER_OF_SUB_PAGE_MEMO_TEXT = 250;

/**
 *  홈 페이지 타입
 */
export const HOME_TYPE = {
  /**
   *  메인 페이지
   */
  MAIN: 0,
  /**
   *  서브 페이지
   */
  SUB: 1,
};

/**
 *  홈 페이지 상태
 */
export const HOME_STATUS = {
  /**
   *  비활성
   */
  INACTIVE: 0,
  /**
   *  활성
   */
  ACTIVE: 1,
  /**
   *  삭제
   */
  DELETE: 2,
};
